/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index'
import { Route as OnboardingPersonalizeRouteImport } from './routes/onboarding.personalize'
import { Route as OnboardingConnectRouteImport } from './routes/onboarding.connect'
import { Route as OnboardingActivateRouteImport } from './routes/onboarding.activate'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations.accept'
import { Route as AppSocialAccountsRouteImport } from './routes/_app/social-accounts'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppPublishingRouteImport } from './routes/_app/publishing'
import { Route as AppPricingRouteImport } from './routes/_app/pricing'
import { Route as AppOrganizationsRouteImport } from './routes/_app/organizations'
import { Route as AppMembersRouteImport } from './routes/_app/members'
import { Route as AppInvitationsRouteImport } from './routes/_app/invitations'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppApiKeysRouteImport } from './routes/_app/api-keys'
import { Route as AppApiDocsRouteImport } from './routes/_app/api-docs'
import { Route as AppAccountDetailsRouteImport } from './routes/_app/account-details'
import { Route as AppPublishingIndexRouteImport } from './routes/_app/publishing.index'
import { Route as InvitationsTokenAcceptRouteImport } from './routes/invitations.$token.accept'
import { Route as AppPublishingNewRouteImport } from './routes/_app/publishing.new'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingPersonalizeRoute = OnboardingPersonalizeRouteImport.update({
  id: '/personalize',
  path: '/personalize',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingConnectRoute = OnboardingConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingActivateRoute = OnboardingActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => OnboardingRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSocialAccountsRoute = AppSocialAccountsRouteImport.update({
  id: '/social-accounts',
  path: '/social-accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/settings.lazy').then((d) => d.Route))
const AppPublishingRoute = AppPublishingRouteImport.update({
  id: '/publishing',
  path: '/publishing',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingRoute = AppPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsRoute = AppOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const AppInvitationsRoute = AppInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppApiKeysRoute = AppApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const AppApiDocsRoute = AppApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountDetailsRoute = AppAccountDetailsRouteImport.update({
  id: '/account-details',
  path: '/account-details',
  getParentRoute: () => AppRoute,
} as any)
const AppPublishingIndexRoute = AppPublishingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPublishingRoute,
} as any)
const InvitationsTokenAcceptRoute = InvitationsTokenAcceptRouteImport.update({
  id: '/invitations/$token/accept',
  path: '/invitations/$token/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPublishingNewRoute = AppPublishingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppPublishingRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/account-details': typeof AppAccountDetailsRoute
  '/api-docs': typeof AppApiDocsRoute
  '/api-keys': typeof AppApiKeysRoute
  '/dashboard': typeof AppDashboardRoute
  '/home': typeof AppHomeRoute
  '/insights': typeof AppInsightsRoute
  '/invitations': typeof AppInvitationsRoute
  '/members': typeof AppMembersRoute
  '/organizations': typeof AppOrganizationsRoute
  '/pricing': typeof AppPricingRoute
  '/publishing': typeof AppPublishingRouteWithChildren
  '/settings': typeof AppSettingsRoute
  '/social-accounts': typeof AppSocialAccountsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/activate': typeof OnboardingActivateRoute
  '/onboarding/connect': typeof OnboardingConnectRoute
  '/onboarding/personalize': typeof OnboardingPersonalizeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/publishing/new': typeof AppPublishingNewRoute
  '/invitations/$token/accept': typeof InvitationsTokenAcceptRoute
  '/publishing/': typeof AppPublishingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-details': typeof AppAccountDetailsRoute
  '/api-docs': typeof AppApiDocsRoute
  '/api-keys': typeof AppApiKeysRoute
  '/dashboard': typeof AppDashboardRoute
  '/home': typeof AppHomeRoute
  '/insights': typeof AppInsightsRoute
  '/invitations': typeof AppInvitationsRoute
  '/members': typeof AppMembersRoute
  '/organizations': typeof AppOrganizationsRoute
  '/pricing': typeof AppPricingRoute
  '/settings': typeof AppSettingsRoute
  '/social-accounts': typeof AppSocialAccountsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/activate': typeof OnboardingActivateRoute
  '/onboarding/connect': typeof OnboardingConnectRoute
  '/onboarding/personalize': typeof OnboardingPersonalizeRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/publishing/new': typeof AppPublishingNewRoute
  '/invitations/$token/accept': typeof InvitationsTokenAcceptRoute
  '/publishing': typeof AppPublishingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/_app/account-details': typeof AppAccountDetailsRoute
  '/_app/api-docs': typeof AppApiDocsRoute
  '/_app/api-keys': typeof AppApiKeysRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/insights': typeof AppInsightsRoute
  '/_app/invitations': typeof AppInvitationsRoute
  '/_app/members': typeof AppMembersRoute
  '/_app/organizations': typeof AppOrganizationsRoute
  '/_app/pricing': typeof AppPricingRoute
  '/_app/publishing': typeof AppPublishingRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_app/social-accounts': typeof AppSocialAccountsRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/activate': typeof OnboardingActivateRoute
  '/onboarding/connect': typeof OnboardingConnectRoute
  '/onboarding/personalize': typeof OnboardingPersonalizeRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_app/publishing/new': typeof AppPublishingNewRoute
  '/invitations/$token/accept': typeof InvitationsTokenAcceptRoute
  '/_app/publishing/': typeof AppPublishingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/account-details'
    | '/api-docs'
    | '/api-keys'
    | '/dashboard'
    | '/home'
    | '/insights'
    | '/invitations'
    | '/members'
    | '/organizations'
    | '/pricing'
    | '/publishing'
    | '/settings'
    | '/social-accounts'
    | '/invitations/accept'
    | '/oauth/consent'
    | '/onboarding/activate'
    | '/onboarding/connect'
    | '/onboarding/personalize'
    | '/onboarding/'
    | '/publishing/new'
    | '/invitations/$token/accept'
    | '/publishing/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-details'
    | '/api-docs'
    | '/api-keys'
    | '/dashboard'
    | '/home'
    | '/insights'
    | '/invitations'
    | '/members'
    | '/organizations'
    | '/pricing'
    | '/settings'
    | '/social-accounts'
    | '/invitations/accept'
    | '/oauth/consent'
    | '/onboarding/activate'
    | '/onboarding/connect'
    | '/onboarding/personalize'
    | '/onboarding'
    | '/publishing/new'
    | '/invitations/$token/accept'
    | '/publishing'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/onboarding'
    | '/_app/account-details'
    | '/_app/api-docs'
    | '/_app/api-keys'
    | '/_app/dashboard'
    | '/_app/home'
    | '/_app/insights'
    | '/_app/invitations'
    | '/_app/members'
    | '/_app/organizations'
    | '/_app/pricing'
    | '/_app/publishing'
    | '/_app/settings'
    | '/_app/social-accounts'
    | '/invitations/accept'
    | '/oauth/consent'
    | '/onboarding/activate'
    | '/onboarding/connect'
    | '/onboarding/personalize'
    | '/onboarding/'
    | '/_app/publishing/new'
    | '/invitations/$token/accept'
    | '/_app/publishing/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
  OauthConsentRoute: typeof OauthConsentRoute
  InvitationsTokenAcceptRoute: typeof InvitationsTokenAcceptRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/personalize': {
      id: '/onboarding/personalize'
      path: '/personalize'
      fullPath: '/onboarding/personalize'
      preLoaderRoute: typeof OnboardingPersonalizeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/connect': {
      id: '/onboarding/connect'
      path: '/connect'
      fullPath: '/onboarding/connect'
      preLoaderRoute: typeof OnboardingConnectRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/activate': {
      id: '/onboarding/activate'
      path: '/activate'
      fullPath: '/onboarding/activate'
      preLoaderRoute: typeof OnboardingActivateRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/social-accounts': {
      id: '/_app/social-accounts'
      path: '/social-accounts'
      fullPath: '/social-accounts'
      preLoaderRoute: typeof AppSocialAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/publishing': {
      id: '/_app/publishing'
      path: '/publishing'
      fullPath: '/publishing'
      preLoaderRoute: typeof AppPublishingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing': {
      id: '/_app/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AppPricingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations': {
      id: '/_app/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AppOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invitations': {
      id: '/_app/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof AppInvitationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-keys': {
      id: '/_app/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AppApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-docs': {
      id: '/_app/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof AppApiDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account-details': {
      id: '/_app/account-details'
      path: '/account-details'
      fullPath: '/account-details'
      preLoaderRoute: typeof AppAccountDetailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/publishing/': {
      id: '/_app/publishing/'
      path: '/'
      fullPath: '/publishing/'
      preLoaderRoute: typeof AppPublishingIndexRouteImport
      parentRoute: typeof AppPublishingRoute
    }
    '/invitations/$token/accept': {
      id: '/invitations/$token/accept'
      path: '/invitations/$token/accept'
      fullPath: '/invitations/$token/accept'
      preLoaderRoute: typeof InvitationsTokenAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/publishing/new': {
      id: '/_app/publishing/new'
      path: '/new'
      fullPath: '/publishing/new'
      preLoaderRoute: typeof AppPublishingNewRouteImport
      parentRoute: typeof AppPublishingRoute
    }
  }
}

interface AppPublishingRouteChildren {
  AppPublishingNewRoute: typeof AppPublishingNewRoute
  AppPublishingIndexRoute: typeof AppPublishingIndexRoute
}

const AppPublishingRouteChildren: AppPublishingRouteChildren = {
  AppPublishingNewRoute: AppPublishingNewRoute,
  AppPublishingIndexRoute: AppPublishingIndexRoute,
}

const AppPublishingRouteWithChildren = AppPublishingRoute._addFileChildren(
  AppPublishingRouteChildren,
)

interface AppRouteChildren {
  AppAccountDetailsRoute: typeof AppAccountDetailsRoute
  AppApiDocsRoute: typeof AppApiDocsRoute
  AppApiKeysRoute: typeof AppApiKeysRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppHomeRoute: typeof AppHomeRoute
  AppInsightsRoute: typeof AppInsightsRoute
  AppInvitationsRoute: typeof AppInvitationsRoute
  AppMembersRoute: typeof AppMembersRoute
  AppOrganizationsRoute: typeof AppOrganizationsRoute
  AppPricingRoute: typeof AppPricingRoute
  AppPublishingRoute: typeof AppPublishingRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRoute
  AppSocialAccountsRoute: typeof AppSocialAccountsRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountDetailsRoute: AppAccountDetailsRoute,
  AppApiDocsRoute: AppApiDocsRoute,
  AppApiKeysRoute: AppApiKeysRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppHomeRoute: AppHomeRoute,
  AppInsightsRoute: AppInsightsRoute,
  AppInvitationsRoute: AppInvitationsRoute,
  AppMembersRoute: AppMembersRoute,
  AppOrganizationsRoute: AppOrganizationsRoute,
  AppPricingRoute: AppPricingRoute,
  AppPublishingRoute: AppPublishingRouteWithChildren,
  AppSettingsRoute: AppSettingsRoute,
  AppSocialAccountsRoute: AppSocialAccountsRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface OnboardingRouteChildren {
  OnboardingActivateRoute: typeof OnboardingActivateRoute
  OnboardingConnectRoute: typeof OnboardingConnectRoute
  OnboardingPersonalizeRoute: typeof OnboardingPersonalizeRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingActivateRoute: OnboardingActivateRoute,
  OnboardingConnectRoute: OnboardingConnectRoute,
  OnboardingPersonalizeRoute: OnboardingPersonalizeRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  OauthConsentRoute: OauthConsentRoute,
  InvitationsTokenAcceptRoute: InvitationsTokenAcceptRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
